export enum RemoteCommandType {
  UNSPECIFIED = 'COMMAND_TYPE_UNSPECIFIED',
  LOCK_UNLOCK = 'COMMAND_TYPE_LOCK_UNLOCK',
  RESET = 'COMMAND_TYPE_RESET',
  RECEIVED = 'COMMAND_TYPE_RECEIVED',
  START_INITIAL_SHIPMENT = 'COMMAND_TYPE_START_INITIAL_SHIPMENT',
  START_RETURN_SHIPMENT = 'COMMAND_TYPE_START_RETURN_SHIPMENT',
  CONFIRM_SHIPMENT = 'COMMAND_TYPE_CONFIRM_SHIPMENT',
  CANCEL_SHIPMENT = 'COMMAND_TYPE_CANCEL_SHIPMENT',
  CLEANUP = 'COMMAND_TYPE_CLEANUP',
}

export enum RemoteCommandStatus {
  QUEUED = 'REMOTE_COMMAND_STATUS_QUEUED',
  IN_PROGRESS = 'REMOTE_COMMAND_STATUS_IN_PROGRESS',
  SUCCEEDED = 'REMOTE_COMMAND_STATUS_SUCCEEDED',
  FAILED = 'REMOTE_COMMAND_STATUS_FAILED',
  TIMEOUT = 'REMOTE_COMMAND_STATUS_TIMEOUT',
  REJECTED = 'REMOTE_COMMAND_STATUS_REJECTED',
  REMOVED = 'REMOTE_COMMAND_STATUS_REMOVED',
  CANCELED = 'REMOTE_COMMAND_STATUS_CANCELED',
  UNSPECIFIED = 'REMOTE_COMMAND_STATUS_UNSPECIFIED',
}
